import sdk from "matrix-js-sdk"
import { resolve } from "dns";
import { reject } from "q";
import { IndexedDBStore } from "matrix-js-sdk/lib/store/indexeddb";

const matrixBaseUrl = 'https://msg.tebinja.com';
const matrixBaseDomain = 'msg.tebinja.com';
let client
let matrixToken// = "MDAxZGxvY2F0aW9uIG1zZy50ZWJpbmphLmNvbQowMDEzaWRlbnRpZmllciBrZXkKMDAxMGNpZCBnZW4gPSAxCjAwMzdjaWQgdXNlcl9pZCA9IEBzYWZhcmJlY29tX19tanNvbGdpOm1zZy50ZWJpbmphLmNvbQowMDE2Y2lkIHR5cGUgPSBhY2Nlc3MKMDAyMWNpZCBub25jZSA9IFFVTVptVXlrLSxDU3NzflMKMDAyZnNpZ25hdHVyZSBm4FRACCoGxC4ypUt99wC_26ADBcA9xXO3284SBFJgTwo";
let userId// = "@safarbecom__mjsolgi:msg.tebinja.com";
let token// = "9758156e23522d47ab3faf135d148fe5073cfc0e";


getAccessToken()
getUserId()
getToken()

function isLoggedIn() {
  if (!matrixToken || !token) return false
  return true
}

async function logout() {
  try {
    if (client) await client.logout()
    localStorage.removeItem('msgToken')
    localStorage.removeItem('userId')
    localStorage.removeItem('token')
    localStorage.clear()
    token = ''
    matrixToken = ''
    userId = ''
  } catch (e) {
    console.log(e)
  }
}

function setAccessToken(_msgToken) {
  localStorage.setItem("msgToken", _msgToken);
  matrixToken = _msgToken
}
function getAccessToken() {
  if (!matrixToken) {
    matrixToken = localStorage.getItem('msgToken')
  }
  return matrixToken
}

function userIdToMatrixFormat(username) {
  if (!username) return null
  return '@' + 'matrix' + username.replace(/@/, '/') + ":" + matrixBaseDomain
}

function setUserId(_userId) {
  localStorage.setItem("userId", _userId);
  userId = userIdToMatrixFormat(_userId)
}
function getUserId() {
  if (!userId) {
    userId = userIdToMatrixFormat(localStorage.getItem('userId'))
  }
  return userId
}

function getToken() {
  if (!token) {
    token = localStorage.getItem('token')
  }
  return token
  //TODO -- get token from LocalStorage
};

function setToken(_token) {
  localStorage.setItem("token", _token);
  token = _token
}

function login() {
  return new Promise((resolve, reject) => {

    const mustInvite = []
    try {
      if (client) return resolve(client)
      console.log("there is no CLIENT !!!!")
      let store = new IndexedDBStore({ indexedDB: window.indexedDB, dbName: 'tebinja-' + localStorage.getItem('userId') });
      store.startup().then(() => {
        client = sdk.createClient({
          baseUrl: matrixBaseUrl,
          accessToken: matrixToken,
          userId: userId,
          timelineSupport: true,
          store: store
        });



        client.once('sync', function (state, prevState, res) {
          if (state === 'PREPARED') {
            console.log("prepared");
            mustInvite.forEach(roomid => {
              client.joinRoom(roomid).then(function () {
                // console.log("Auto-joined %s", roomid);
              });
            })
            return resolve(client)
          } else {
            // console.log(state);
            return reject(state)
          }
        });


        client.startClient({ initialSyncLimit: 20 });
        client.on("RoomMember.membership", function (event, member) {
          if (member.membership === "invite" && member.userId === getUserId()) {
            if (client.isInitialSyncComplete()) {
              client.joinRoom(member.roomId).then(function () {
                // console.log("Auto-joined %s", member.roomId);
              });
            } else {
              mustInvite.push(member.roomId)
            }
          }
        });
      })


    } catch (e) {
      console.log(e, ' login request result');
      return reject(e)
      // console.warn(e.message, ' login request result');
    }
  })
};

export default {
  client,
  getToken: getToken,
  setToken,
  login,
  getAccessToken,
  setAccessToken,
  getUserId,
  setUserId,
  isLoggedIn,
  logout,
  matrixBaseDomain
}
